import { PutObjectCommandOutput, S3 } from "@aws-sdk/client-s3";
import { getUniqueId } from "shared/uniqueId/getUniqueId";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";

import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

export interface UploadFileToS3ReturnType {
  s3Response: PutObjectCommandOutput;
  key: string;
}
export async function uploadFileToS3(
  file: File,
  identityPoolId: string,
  bucketRegion: string,
  bucketName: string,
  key: string,
  appendRandomFileNameSuffix: boolean = true
): Promise<UploadFileToS3ReturnType> {
  const finalKey = appendRandomFileNameSuffix
    ? `${key}${getUniqueId("file-upload")}-${file.name}`
    : key;
  const client = new S3({
    region: bucketRegion,
    maxAttempts: 2,
    credentials: fromCognitoIdentityPool({
      client: new CognitoIdentityClient({ region: bucketRegion }),
      identityPoolId: identityPoolId,
    }),
  });

  const response = await client.putObject({
    Bucket: bucketName,
    Key: finalKey,
    Body: file,
  });

  return { s3Response: response, key: finalKey };
}
